<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top',
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
    orange_theme: options.activeTheme == 'orange_theme',
    blue_theme: options.activeTheme == 'blue_theme',
    aqua_theme: options.activeTheme == 'aqua_theme',
    purple_theme: options.activeTheme == 'purple_theme',
    green_theme: options.activeTheme == 'green_theme',
    cyan_theme: options.activeTheme == 'cyan_theme'
  }"
  [dir]="options.dir!"
>
  <!-- Vertical Sidebar - Mobile & Desktop -->
  <mat-sidenav
    #leftsidenav
    [mode]="isOver ? 'over' : 'side'"
    [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
    *ngIf="!options.horizontal && !hideSidebar"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
  >
    <div class="flex-layout">
      <app-branding></app-branding>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          <navigation-item
            *ngFor="let item of mainNavigation"
            [item]="item"
            (notify)="sidenav.toggle()"
          >
          </navigation-item>
        </mat-nav-list>
      </ng-scrollbar>
      <div *ngIf="profile" class="p-24 m-t-auto profile-bar">
        <div class="bg-light-accent d-flex align-items-center rounded p-16">
          <img
            [src]="profile.userPicture ? 'data:image/png;base64,' + profile.userPicture : '/assets/images/profile/user-1.jpg'"
            class="rounded-circle"
            width="40"
          />
          <div class="m-l-16">
            <h5 class="mat-subtitle-2 f-w-600">{{ profile.userFullName }}</h5>
            <!-- <span class="f-s-12">Designer</span> -->
          </div>
          <div class="m-l-auto">
            <a
              mat-icon-button
              [routerLink]="['/login']"
              class="d-flex justify-content-center"
            >
              <i-tabler
                name="power"
                class="text-primary icon-18 d-flex"
              ></i-tabler>
            </a>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <!-- Horizontal Sidebar - Mobile -->
  <mat-sidenav
    #leftsidenav
    [mode]="'over'"
    [opened]="options.sidenavOpened && !isTablet"
    *ngIf="resView && !hideSidebar"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
  >
    <app-branding></app-branding>
    <ng-scrollbar class="position-relative" style="height: 100%">
      <mat-nav-list class="sidebar-list">
        horizontal menu here, acelasi ca mai sus
      </mat-nav-list>
    </ng-scrollbar>
    <div class="p-24 m-t-auto profile-bar">
      <div class="bg-light-accent d-flex align-items-center rounded p-16">
        <img
          src="/assets/images/profile/user-1.jpg"
          class="rounded-circle"
          width="40"
        />
        <div class="m-l-16">
          <h5 class="mat-subtitle-2 f-w-600">Mathew</h5>
          <span class="f-s-12">Designer</span>
        </div>
        <div class="m-l-auto">
          <a
            mat-icon-button
            [routerLink]="['/authentication/side-login']"
            class="d-flex justify-content-center"
          >
            <i-tabler
              name="power"
              class="text-primary icon-18 d-flex"
            ></i-tabler>
          </a>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content class="contentWrapper" #content>
    <ng-container *ngIf="!options.horizontal; else horizontalheader">
      <app-vertical-header
        [profile]="profile"
        [showToggle]="!isOver"
        [hideMenuToggle]="hideSidebar"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="filterNavRight.toggle()"
      ></app-vertical-header>
    </ng-container>

    <ng-template #horizontalheader>
      <app-horizontal-header
        (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="filterNavRight.toggle()"
      ></app-horizontal-header>
      <app-horizontal-navigation></app-horizontal-navigation>
    </ng-template>

    <main class="pageWrapper" [ngClass]="{ maxWidth: options.boxed }">
      <app-breadcrumb></app-breadcrumb>
      <router-outlet></router-outlet>
      <div class="customizerBtn">
        <button mat-fab color="primary" (click)="customizerRight.toggle()">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </main>
  </mat-sidenav-content>
  <mat-sidenav #customizerRight mode="over" position="end">
    <div class="p-x-16 p-y-20 d-flex align-items-center justify-content-between">
      <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">
        X
      </button>
    </div>
    <mat-divider></mat-divider>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<!-- Secondary Navigation - Mobile -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div>
    <div class="d-flex p-24 justify-content-between align-items-center">
      <div class="branding"></div>
      <button
        mat-icon-button
        (click)="filterNavRight.toggle()"
        class="d-flex justify-content-center"
      >
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
  </div>
</mat-drawer>
